import { Row } from 'antd';
import React from 'react';
import LoadingBox from "../../../../../components/LoadingBox";
import Phone from "../../../../../components/Location/Phone";
import Position from "../../../../../components/Location/Position";
import ProductionArea from "../../../../../components/Location/ProductionArea";
import { useSiteDetail } from "../../../../../contexts/SiteDetailContext";
import FishDisease from "../../../../DashboardPage/_components/FishDisease";
import styles from "../style.module.scss";
import Section from "./Section";
import SiteDiseases from "./SiteDiseases";
import Units from "./Units";

const NoSite = () => {
    const [loading] = useSiteDetail(state => state.loadingSite);

    return <LoadingBox className="mt-3" loading={loading} />
}

interface IProps {
}

const Info: React.FC<IProps> = () => {
    const [site] = useSiteDetail(state => state.site);

    if (!site)
        return <NoSite />;

    return <Row className={styles.smallBox} gutter={[16, 18]}>
        <Section>
            <div className={styles.lineName}>Site detail info</div>
            <Phone data={site} />
            <Position data={site} />
            <ProductionArea data={site} />
            <SiteDiseases site={site} />
        </Section>
        <Section>
            <div className={styles.lineName}>Site lice info</div>
            <FishDisease data={site.diseases} />
        </Section>
        {/*<Section>*/}
        {/*    /!*<div className='flex items-center gap-[20px] mb-2'>*!/*/}
        {/*    /!*    <div className='font-semibold text-[15px]'>Add disease into site</div>*!/*/}
        {/*    /!*    <div className='link' onClick={() => openPage(PATHNAME.DISEASE)}>Define new disease</div>*!/*/}
        {/*    /!*</div>*!/*/}
        {/*    /!*<div className='mb-[25px]'>*!/*/}
        {/*    /!*    <Diseases site_id={site.id} unit_diseases={site.units[0]?.unit_diseases}/>*!/*/}
        {/*    /!*</div>*!/*/}
        {/*    <AssignServiceCargo*/}
        {/*        location={site}*/}
        {/*        locationType={MAP_ELEMENT.SITE}*/}
        {/*        onSave={materials => set(({site: prev}) => ({*/}
        {/*            site: prev ? {...prev, inventory: materials} : prev*/}
        {/*        }))}*/}
        {/*    />*/}
        {/*</Section>*/}
        <Section sm={24}>
            <Units />
        </Section>
    </Row>
};

export default Info;
